import { Alert, Button } from "@mui/material";
import {
  COUNT_CAP,
  useRecentlyEditedTotal,
  useUpcomingSendsTotal,
} from "../../hooks/use-others-content-count";

import type { RecentlyEditedType } from "../../hooks/use-recently-edited";
import type { FC } from "react";

/** "there is 1 item", "there are 3 items", or past the cap, "there are 100+ items". */
const thereAre = (count: number): string => {
  if (count === 1) return "there is 1 item";
  return `there are ${count > COUNT_CAP ? `${COUNT_CAP}+` : count} items`;
};

/**
 * Above an empty feed while My Content only is on: how many others have, and a way to see them.
 * Nothing while that's counted, if it can't be, or when there are none.
 */
const OthersContentAlert: FC<{
  count: number | null;
  onViewAll: () => void;
  /** Prefixes the button's analytics id. */
  analyticsId: string;
}> = ({ count, onViewAll, analyticsId }) => {
  if (!count) return null;

  return (
    <Alert
      severity="info"
      sx={{ maxWidth: 768, mx: "auto", mt: 1 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={onViewAll}
          data-analytics-id={`${analyticsId}-view-all`}
        >
          View all
        </Button>
      }
    >
      Your content only - {thereAre(count)} created by/edited by others
    </Alert>
  );
};

/** Everything Recently edited would list of `entityType`, or every kind, with the switch off. */
export const RecentlyEditedOthersAlert: FC<{
  entityType?: RecentlyEditedType;
  onViewAll: () => void;
}> = ({ entityType, onViewAll }) => {
  const { data } = useRecentlyEditedTotal(entityType);

  return (
    <OthersContentAlert
      count={data}
      onViewAll={onViewAll}
      analyticsId="dashboard-recently-edited"
    />
  );
};

/** Upcoming sends with the switch off. */
export const UpcomingSendsOthersAlert: FC<{ onViewAll: () => void }> = ({ onViewAll }) => {
  const { data } = useUpcomingSendsTotal();

  return (
    <OthersContentAlert count={data} onViewAll={onViewAll} analyticsId="dashboard-upcoming-sends" />
  );
};
